import React, { useContext, useState } from "react";
import { FormDataContext } from "context/FormDataContext";
import styled from "styled-components";

export default function SelectOrganization() {
  const { updateCurrentOrganization, organizations } =
    useContext(FormDataContext);
  const [panelStatus, setPanelStatus] = useState(false);

  const handleSelectOrganization = (organization) => {
    updateCurrentOrganization(organization);
    setPanelStatus(!panelStatus);
  };

  const handlePanelStatus = (e) => {
    e.preventDefault();
    setPanelStatus(!panelStatus);
  };

  const organizationList = organizations.map((organization, i) => {
    return (
      <PanelListItem
        onClick={() => handleSelectOrganization(organization)}
        key={i}
      >
        {organization[1]}
      </PanelListItem>
    );
  });

  if (organizations.length > 1) {
    return (
      <PanelWrapper>
        <PanelSwitch onClick={(e) => handlePanelStatus(e)}>
          Vælg menighedsråd
        </PanelSwitch>
        {panelStatus === true && <Panel>{organizationList}</Panel>}
      </PanelWrapper>
    );
  } else {
    return null;
  }
}

const PanelWrapper = styled.div`
  position: relative;
`;

const Panel = styled.ul`
  color: #000;
  cursor: pointer;
  margin: 0;
  padding: 0.25em;
  font-size: 0.85em;
  border: 1px solid ${(props) => props.theme.color.primary};
  position: absolute;
  background-color: #fff;
  min-width: 200px;
  right: 0;
`;

const PanelListItem = styled.li`
  list-style: none;
  padding: 0.25em 0.5em;
  white-space: nowrap;
  &:hover {
    background: #f3f3f3;
  }
`;

const PanelSwitch = styled.button`
  cursor: pointer;
  margin-bottom: 2px;
`;
